import React from "react";

const FrameMob = () => {
  return (
    <svg
      className="frame"
      xmlns="http://www.w3.org/2000/svg"
      width="237"
      height="237"
      viewBox="0 0 237 237"
    >
      <script xmlns="" />
      <script xmlns="" />
      <g id="그룹_873" data-name="그룹 873" transform="translate(-20 -983)">
        <path
          id="패스_1321"
          data-name="패스 1321"
          d="M20.432,0V18.839H70.1V101.9H92.5V0Z"
          transform="translate(164.5 983)"
          fill="#fff"
        />
        <path
          id="패스_1407"
          data-name="패스 1407"
          d="M20.432,0V18.839H70.1V101.9H92.5V0Z"
          transform="translate(112.5 1220) rotate(180)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default FrameMob;
